import React from 'react';

const steps = [
  {
    num: '1', day: 'JOUR 1', title: 'Brief',
    desc: 'Vous remplissez un formulaire structuré : identité de marque, pages, fonctionnalités, charte graphique. 15 minutes suffisent.',
    icon: '📋',
  },
  {
    num: '2', day: 'JOURS 2–4', title: 'Pipeline IA',
    desc: 'Notre pipeline automatisé génère la structure, les contenus, le design et le code. Chaque étape est supervisée par notre équipe.',
    icon: '⚗️',
  },
  {
    num: '3', day: 'JOUR 10', title: 'Site livré',
    desc: 'Votre site est en ligne, optimisé SEO, mobile-first et prêt à convertir. Livraison avec formation et documentation incluses.',
    icon: '🚀',
  },
];

export default function Process() {
  return (
    <section id="process" style={{
      background: '#0d0d14', padding: '7rem 2rem',
    }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <p style={{
            color: '#7C3AED', fontWeight: 600, fontSize: 12,
            letterSpacing: '0.15em', textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>LE PROCESSUS</p>
          <h2 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800,
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            lineHeight: 1.1, letterSpacing: '-0.02em',
          }}>
            De l'idée au site en{' '}
            <span style={{ color: '#A78BFA' }}>3 étapes</span>
          </h2>
          <p style={{ color: '#8b8b9a', marginTop: '1rem', fontSize: 16 }}>
            Un processus rodé, entièrement piloté par l'IA et supervisé par des humains.
          </p>
        </div>

        {/* Steps */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem',
        }}>
          {steps.map((s, i) => (
            <div key={i} style={{
              background: '#13131d',
              border: '1px solid rgba(124,58,237,0.15)',
              borderRadius: 16, padding: '2rem',
              position: 'relative',
              transition: 'border-color 0.3s, transform 0.3s',
              cursor: 'default',
            }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'rgba(124,58,237,0.4)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'rgba(124,58,237,0.15)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {/* Number badge */}
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                background: '#7C3AED', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontSize: 13, fontWeight: 700,
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                marginBottom: '1.5rem',
              }}>{s.num}</div>

              {/* Icon */}
              <div style={{
                width: 52, height: 52, borderRadius: 12,
                background: 'rgba(124,58,237,0.12)',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontSize: 24,
                marginBottom: '1.2rem',
              }}>{s.icon}</div>

              <p style={{
                color: '#7C3AED', fontSize: 11,
                fontWeight: 600, letterSpacing: '0.1em',
                textTransform: 'uppercase', marginBottom: 8,
              }}>{s.day}</p>
              <h3 style={{
                fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '1.3rem',
                fontWeight: 700, marginBottom: '1rem',
              }}>{s.title}</h3>
              <p style={{ color: '#8b8b9a', fontSize: 14, lineHeight: 1.7 }}>{s.desc}</p>
            </div>
          ))}
        </div>

        {/* Badge */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            background: 'rgba(124,58,237,0.1)',
            border: '1px solid rgba(124,58,237,0.25)',
            borderRadius: 50, padding: '10px 24px',
            fontSize: 14, color: '#c4c4d0',
          }}>
            <span style={{ color: '#7C3AED', fontSize: 18 }}>✓</span>
            Révisions illimitées pendant 30 jours après livraison
          </div>
        </div>
      </div>
    </section>
  );
}
